export const MOBILE_DRAG_ACTIVATION_DELAY = 300;
export const DESKTOP_DRAG_ACTIVATION_DELAY = 400;
